<template>

    <b-row class="pt-5 cont-donuts">
        <div v-if="mainValues.hasHidro" cols="3" :class="hasAll()">
            <div>
                <h4>{{ (hidroInfo.is_electrolysis) ? $t("messages.electro") :  $t("messages.hidro") }}</h4>
                <p>{{hidroInfo.current / 10 }} {{hidroInfo.measure}}</p>
            </div>
        </div>
        <div v-if="mainValues.hasPH" cols="3" class="donut">
            <vue-easy-pie-chart :percent="(modulesInfo.ph.current*100)/modulesInfo.ph.status.high_value" :line-width="8" :scaleLength="0" :bar-color="getPhColor(modulesInfo.ph.type)">
                <p>{{ parseFloat(modulesInfo.ph.current / 100).toFixed(1) }}</p>
            </vue-easy-pie-chart>
            <h4>pH</h4>
            <div align="left" class="counters">
                <p v-if="modulesInfo.ph.type === 'ACID'">
                    <icon name="caret-up"></icon> {{ parseFloat(modulesInfo.ph.status.high_value / 100).toFixed(1) }} / <span v-bind:class = "(modulesInfo.ph.pump_high_on === 1)?'green':''">{{ (modulesInfo.ph.pump_high_on === 0) ?  $t("messages.off") : $t("messages.on") }}</span>
                </p> 
                <p v-if="modulesInfo.ph.type === 'BASE'">
                    <!-- OFF ON -->
                   <icon name="caret-down"></icon>   {{ parseFloat(modulesInfo.ph.status.low_value / 100).toFixed(1) }} / {{ (modulesInfo.ph.pump_high_on === 0) ? $t("messages.off")  :  $t("messages.on") }}
                </p>
               <p v-if="modulesInfo.ph.type === 'ACID/BASE'">
                    <icon name="caret-up"></icon> {{ parseFloat(modulesInfo.ph.status.high_value / 100).toFixed(1) }} /  <span v-bind:class = "(modulesInfo.ph.pump_high_on === 1)?'green':''"> {{ (modulesInfo.ph.pump_high_on === 0) ? $t("messages.off")  :  $t("messages.on") }}</span>
               </p>
               <p v-if="modulesInfo.ph.type === 'ACID/BASE'">
                    <icon name="caret-down"></icon>   {{ parseFloat(modulesInfo.ph.status.low_value / 100).toFixed(1) }} / {{ (modulesInfo.ph.pump_low_on === 0) ? $t("messages.off")  :  $t("messages.on")  }}
                </p>
            </div>
        </div>
        <div v-if="mainValues.hasRX" cols="3" class="donut">
            <vue-easy-pie-chart :percent="(modulesInfo.rx.current/modulesInfo.rx.status.value)*100" :line-width="8" :scaleLength="0" :bar-color="getRxColor()">
                <p>{{modulesInfo.rx.current}}</p>
            </vue-easy-pie-chart>
            <h4>rX</h4>
            <div align="left" class="counters">
                <p>
                    <icon name="caret-up"></icon> {{modulesInfo.rx.status.value}}
                </p>
            </div>
        </div>

        <div v-if="mainValues.hasCD" cols="3" class="donut">
            <vue-easy-pie-chart :percent="(modulesInfo.cd.current/modulesInfo.cd.status.value)*100" :line-width="8" :scaleLength="0" :bar-color="getCDColor()">
                <p>{{modulesInfo.cd.current}}</p>
            </vue-easy-pie-chart>
            <h4>CD</h4>
             <div align="left" class="counters">
                <p>
                    <icon name="caret-up"></icon> {{modulesInfo.cd.status.value}}
                </p>
            </div>
        </div>
        <div v-if="mainValues.hasCL" cols="3" class="donut">
            <vue-easy-pie-chart :percent="(modulesInfo.cl.current/modulesInfo.cl.status.value)*100" :line-width="8" :scaleLength="0" :bar-color="getCLColor()">
                <p>{{ parseFloat(modulesInfo.cl.current / 100).toFixed(2) }}</p>
            </vue-easy-pie-chart>
            <h4>CL</h4>
            <div align="left" class="counters">
                <p>
                    <icon name="caret-up"></icon> {{ parseFloat(modulesInfo.cl.status.value / 100).toFixed(2)}} 
                </p> 
               
            </div>
        </div>

    </b-row>
</template>

<script>
import VueEasyPieChart from 'vue-easy-pie-chart'
import 'vue-easy-pie-chart/dist/vue-easy-pie-chart.css'

export default {
    name: 'Modules',
    components: { VueEasyPieChart },
    props: {
        present: null,
        updatedAt: null,
        modulesInfo: {},
        hidroInfo: {},
        mainValues: {},
        filtrationStatus: null
    },
    data(){
        return {
            colorModules: [],
            colors: {
                red: '#ff0000',
                orange: '#ffab34',
                green: '#00ffe0',
                grey: '#dddddd',
                blue: '#00b3db'
            }
        }
    },
    mounted(){
        this.$nextTick(() => {
            this.checkSmileColor()
        })
    },
    watch: {
        'modulesInfo': {
            handler(value) {
                 setInterval(() => {
                    this.checkSmileColor()
                 }, 800)
            }
        }
    },
    methods:{
        hasAll(){
            if(this.mainValues.hasPH && this.mainValues.hasCD && this.mainValues.hasRX && this.mainValues.hasCL){
                return 'donut donutBis hasAll';
            } else {
                return (this.filtrationStatus == 0 || !this.present) ? 'donut donutBis' : 'donut donutBis blue'
            }
        },
        checkSmileColor(){
            if(this.filtrationStatus == 0 || !this.present){
                this.$emit('onChangeColor', 'regular')
             } else {
             
               Object.keys(this.colorModules).forEach((key) => {
                   if(this.colorModules[key] === this.colors.red){
                      this.$emit('onChangeColor', 'sad')
                      return
                   }
                 if(this.colorModules[key] === this.colors.orange){
                      this.$emit('onChangeColor', 'regular')
                      return
                   }
                if(this.colorModules[key] === this.colors.green){
                      this.$emit('onChangeColor', 'smile')
                      return
                   }
               });
             }
        },
  
        getPhColor(type){
            if(this.filtrationStatus === 0 || !this.present) return this.colors["grey"]
            var color= null
            var ph= this.modulesInfo.ph.current;
            var phHI = this.modulesInfo.ph.status.high_value 
            var phLO = this.modulesInfo.ph.status.low_value 
            switch(type){
                case 'ACID/BASE':
                   color =  this._getAcidBaseColor(ph, phLO, phHI)
                break;
                case 'ACID':
                   color =  this._getPhColor(ph, phHI)
                break;
                case 'BASE':
                    color =  this._getPhColor(ph, phLO)
                break;
            }
            return color
        },

        _getAcidBaseColor(ph, phLO, phHI){
            let prcHI = (ph / phHI) * 100;
            let prcLO = (ph / phLO) * 100;
            let color = null
            if (prcHI >= 7 || prcHI <= 15) {
                //orange between 8-15%
                color = this.colors["orange"]
            }
            else if (prcHI > 15) {
                color = this.colors["red"]
            }
            else if (prcLO < 92 || prcLO >= 85) {
                color = this.colors["orange"]
            }
            else if (prcLO < 85) {
                color = this.colors["red"]
            }
            else {
                color = this.colors["green"]
            }
            this.colorModules['ph'] = color
            return color 
        },
        _getPhColor(ph, val){
            let phAbsolut = Math.abs((ph / 100) - (val / 100));
            let color = null
            if (phAbsolut >= 1){
                color = this.colors["red"]
            }
            else if (phAbsolut < 1 && phAbsolut >= 0.5) color = this.colors["orange"]
            else color = this.colors["green"]
            this.colorModules['ph'] = color
            return color 
        },
        getRxColor(){
            if(this.filtrationStatus === 0 || !this.present) return this.colors["grey"]
            let color = null
            var rx = this.modulesInfo.rx.current * 100;
            var rx1 = this.modulesInfo.rx.status.value * 100;
            var clAbsolut = Math.abs(100 - (rx / rx1) *100) ;

            if (clAbsolut > 25) {
                color =  this.colors["red"] 
            }   
            else if (clAbsolut <= 25 && clAbsolut >= 15) color =  this.colors["orange"]
            else color =  this.colors["green"]
            this.colorModules['rx'] = color
            return color;
        },
        getCLColor(){
            if(this.filtrationStatus === 0 || !this.present) return this.colors["grey"]
            let color = null
            var cl = this.modulesInfo.cl.current * 100;
            var cl1 = this.modulesInfo.cl.status.value * 100;
            var clAbsolut = Math.abs(100 - (cl / cl1) *100) ;

            if (clAbsolut > 25) {
                color =  this.colors["red"] 
            }   
            else if (clAbsolut <= 25 && clAbsolut >= 15) color =  this.colors["orange"]
            else color =  this.colors["green"]
            this.colorModules['cl'] = color
            return color
        },
        getCDColor(){
            if(this.filtrationStatus === 0 || !this.present) return this.colors["grey"]
            let color = null
            let avg = (this.modulesInfo.cd.current * 100)/this.modulesInfo.cd.status.value
            let clAbsolut = Math.abs(100 - avg);
            let clWarm = 11;
            let clErr = 21;

            if (clAbsolut >= clErr){  
                color =  this.colors["red"]
            }
            else if (clAbsolut >= clWarm) color =  this.colors["orange"]
            else color =  this.colors["green"]
            this.colorModules['cd'] = color
            return color
        }

    }
}
</script>



// WEBPACK FOOTER //
// src/components/Modules.vue